import React from "react";

interface IconProps {
  fill: string;
  title: string;
}

const DriveParameter: React.FC<IconProps> = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96.25" fill={props.fill}>
    <title>{props.title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="drive_parameter">
          <path d="M61.24,56.22c0,.26,0,.53,0,.79L81.75,24,75,19.74,59.27,45A32.74,32.74,0,0,1,61.24,56.22Z" />
          <path d="M28.6,84.52a28.31,28.31,0,1,1,28.31-28.3A28.33,28.33,0,0,1,28.6,84.52Zm0-48.61A20.31,20.31,0,1,0,48.91,56.22,20.33,20.33,0,0,0,28.6,35.91Z" />
          <path d="M28.6,64.22a8,8,0,1,1,8-8A8,8,0,0,1,28.6,64.22Zm0-8h0Z" />
          <path d="M50.64,14.94a19.17,19.17,0,0,1,1.09-6.32L12.86,32.69l4.21,6.8L51,18.49A19,19,0,0,1,50.64,14.94Z" />
          <path d="M69.87,29.88A14.94,14.94,0,1,1,84.81,14.94,15,15,0,0,1,69.87,29.88ZM69.87,8a6.94,6.94,0,1,0,6.94,6.94A6.94,6.94,0,0,0,69.87,8Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default DriveParameter;
